// extracted by mini-css-extract-plugin
export var center = "_5l-2";
export var clickableRow = "_5l-5";
export var expandedRow = "_5l-7";
export var hoverable = "_5l-4";
export var left = "_5l-1";
export var right = "_5l-3";
export var row = "_5l-0";
export var selectedRow = "_5l-6";
export var summaryRow = "_5l-8";